<template>
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--添加核销员-->
      <div class="common-form">添加投资</div>

      <el-form-item label="选择用户">
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">选择会员</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img :src="user_info.avatarUrl" width="100" height="100" />
          </div>
          <div>
            <el-link :underline="false" disabled>选择后不可更改</el-link>
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="公司名称" prop="company" :rules="[{required: true,message: '请输入公司名称'}]">
        <el-input class="max-w460" v-model="form.company" placeholder="请输入公司名称"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile" :rules="[{required: true,message: '请输入联系方式'}]">
        <el-input class="max-w460" v-model="form.mobile" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="投资金额" prop="budget" :rules="[{required: true,message: '请输入投资金额'}]">
        <el-input class="max-w460" v-model="form.budget" placeholder="请输入投资金额"></el-input>
      </el-form-item>

      <el-form-item label="投资行业" prop="category_id">
        <el-select v-model="form.category_id">
          <template v-for="cat in category">
            <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>
            <template v-if="cat.child !== undefined" v-for="two in cat.child">
              <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px;"></el-option>
              <template v-if="two.child !== undefined" v-for="three in two.child">
                <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px;"></el-option>
              </template>
            </template>
          </template>
        </el-select>
      </el-form-item>

      <el-form-item label="投资地区">
        <el-select v-model="form.province_id" placeholder="省" @change="initCity">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
        </el-select>
        <el-select v-if="form.province_id!=''" v-model="form.city_id" placeholder="市" @change="initRegion">
          <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[form.province_id]['city']"
            :key='index1'></el-option>
        </el-select>
        <el-select v-if="form.city_id!=''" v-model="form.region_id" placeholder="区">
          <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[form.province_id]['city'][form.city_id]['region']"
            :key='index2'></el-option>
        </el-select>

      </el-form-item>

      <el-form-item label="投资介绍">
        <el-input type="textarea" v-model="form.introduce" placeholder="请输入投资介绍" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

    <!--添加-->
    <GetUser :is_open="open_add" @close="closeDialogFunc"></GetUser>

  </div>
</template>

<script>
  import projectApi from '@/api/project.js';
  import GetUser from '@/components/user/GetUser.vue';
  import select_region from '@/utils/select.region.js';
  export default {
    components: {
      /*编辑组件*/
      GetUser
    },
    data() {
      return {
        /*切换菜单*/
        // activeIndex: '1',
        /*form表单数据*/
        form: {
          user_id: '',
          status:1,
          real_name: '',
          mobile: '',
          category_id:null,
          province_id: '',
          city_id: '',
          region_id: '',
          introduce:'',
          company:'',
          budget:'',
          type:1,
        },
        user_info: {},
        /*是否打开添加弹窗*/
        open_add: false,
        category: [],
        /*是否正在加载*/
        loading:false,
          /*省市区*/
        areaList: select_region,
      };
    },
    created() {
      console.log(select_region,this.areaList);
      this.getData();
    },

    methods: {

      getData(){
        let self = this;
        projectApi.getProjectData('', true)
          .then(res => {
            self.category = res.data.category;
          })
          .catch(error => {

          });
      },

      /*添加用户*/
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            projectApi.addProject(form, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，核销员添加成功',
                    type: 'success'
                  });
                  self.$router.push('/plus/project/invest/index');
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });


      },

      

      /*打开弹出层*/
      addClick() {
        this.open_add = true;
      },

      /*关闭获取用户弹窗*/
      closeDialogFunc(e) {
        if (e.type != 'error') {
          this.user_info = e.params[0];
          this.form.user_id = e.params[0].user_id;
        }
        this.open_add = false;
      },
      
      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
      /*初始化城市id*/
      initCity() {
        this.form.city_id = ''
      },

      /*初始化区id*/
      initRegion() {
        this.form.region_id = ''
      },


    }

  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/project/invest/add.vue